import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

export default function initI18n(translations: object) {
  i18n
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
      lng: 'en',
      fallbackLng: 'en',
      debug: false,

      resources: {
        en: {
          translation: translations,
        },
      },

      react: {
        useSuspense: false,
      },

      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
    });
}
